/*
 * Copyright (C) 2017 Spanning Cloud Apps LLC.  All rights reserved.
 */
'use strict';

angular
  .module('http.metadata', [])
  /**
   * Service used to manage metadata.
   */
  .factory('httpMetadata', function ($http) {
    /**
     * Return information, and possibly the contents of a backed up metadata item.
     *
     * @param {Object} params - The call options
     * @param {Number} params.batchId -  The id of the source batch
     * @param {String} params.metadataPath - The metadata path
     * @param {String} params.checksum - The metadata checksum
     * @param {Number} [params.maxLineCount] -  - If the data is text and contains more than this number of lines,
     *   don't
     *   include the data in the FileInfo. This helps to prevent transferring large files when they are not needed.
     *   Defaults to unlimited.
     * @param {Boolean} [params.discardBinary] - If true, don't return the contents of binary files. This helps to
     *   prevent transferring binary files when they are not needed.  Defaults to false.
     * @returns {Promise} - A promise that resolves to the FileInfo of the metadata file.
     */
    function getItemFileInfo(params) {
      return $http({
        method: 'GET',
        url: 'api/metadata/item-file',
        params: params
      }).then(function (res) {
        return res.data;
      });
    }

    /**
     * Returns the pre-signed url to export a backed up metadata item.
     *
     * @param {String} sfOrgId - The Salesforce org id of the batch. Needed since it could be a cross-org restore.
     * @param {String} metadataPath - The metadata path of the item to be returned.
     * @param {Number} batchId -  The id of the source batch
     * @returns {Promise} - A promise that resolves to an object containing the url.
     */
    function getItemExportUrl(sfOrgId, metadataPath, batchId) {
      return $http({
        method: 'GET',
        url: 'api/metadata/item-export-url',
        params: {
          sfOrgId: sfOrgId,
          metadataPath: metadataPath,
          batchId: batchId
        }
      }).then(function (res) {
        return res.data;
      });
    }

    return {
      getItemFileInfo: getItemFileInfo,
      getItemExportUrl: getItemExportUrl
    };
  });
